import { AxiosError } from 'axios';

type FormattedError = {
  [key: string]: string;
};

type ErrorResponseData = {
  message?: string;
  errors?: FormattedError;
  statusCode: string;
};

type AxiosRequest = {
  responseURL?: string;
};

export type ErrorMessage = {
  id: string;
  errorMessage: string;
  url: string;
  statusCode: number;
  statusText: string;
};

// eslint-disable-next-line complexity
export function buildError(error: AxiosError): ErrorMessage {
  const request = error.request as AxiosRequest | undefined;
  const statusCode = error.response?.status ?? 0;
  const statusText = error.response?.statusText ?? 'Unknown error';
  const data = error.response?.data as ErrorResponseData | undefined;

  let url = 'unknown';
  let errorMessage = 'Unknown error';

  if (request && request.responseURL) {
    url = request.responseURL;
  }

  if (data && data.message) {
    errorMessage = data.message;
  }

  if (data && typeof data.errors === 'string') {
    errorMessage = data.errors;
  }

  if (data && typeof data.errors === 'object') {
    errorMessage = Object.keys(data.errors)
      .map((k) => (data.errors ? `${k}: ${data.errors[k]}` : ''))
      .join(' | ');
  }

  return {
    id: `${url}-${errorMessage}`,
    errorMessage,
    url,
    statusCode,
    statusText,
  };
}
